import { render, staticRenderFns } from "./sidebar_participant.vue.js?vue&type=template&id=4383e3ce!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sidebar_participant.vue?vue&type=template&id=4383e3ce"
import script from "./sidebar_participant.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sidebar_participant.vue?vue&type=script&lang=js"
export * from "./sidebar_participant.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sidebar_participant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports